


import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";



import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from 'react';
import "./Led.css"
import dolbyGif from "../components/images/Dolby Audio.gif";
import assistantGif from "../components/images/Google Assistant.gif";
import movieGif from "../components/images/MovieBox.gif";
import remoteGif from "../components/images/Bluetooth Voice Remote.gif";
import updateGif from "../components/images/Auto Update.gif";

import BrochurePopup from "../components/BrochurePopup";
import tvBrochure from "../components/images/TV BROCHURE 2026.pdf";
// import led from "./images/led1.jpeg"
// import led2 from "./images/led2.jpeg"
import led3 from "./images/led4.jpeg"
import LED1 from "./images/32inch.jpg"
import LED2 from "./images/42inch.jpg"
import LED3 from "./images/52inch.jpg"
import LED4 from "./images/68inch.jpg"
import inchled from "./images/inchled.jpg"
// import inchled from "./images/Led 98.jpg"
import TV from "./images/tv 2.jpeg"
import Advertise from "./images/ADVERTISE.jpeg"
import Last from "./images/ADVERTISELAST.jpeg"
import television from "./images/98inch.jpg"


// ott

import netflix from './images/netflix.jpg';
import disney from './images/disneylogo.webp';
import prime from './images/PrimeVideo.png';
import hulu from './images/HuluLogopng.png';
import spotify from './images/Spotify.png';
import apple from './images/appleitunes.png';
// import google from './images/g';
import sony from './images/Sony-Liv.jpeg';
import wolfled from "./images/wolfled.jpg"


// import vibrantImg from './images/102inch.jpg';
// import innovativeImg from './images/68inch.jpg';
// import fashionableImg from './images/78inch.jpg';
// import premiumImg from './images/42inch.jpg';
export default function Led() {

const navigate = useNavigate();

  const products = [
    {
      img: LED1,
      name: "32’ Smart TV",
      subtitle: " Experience vibrant picture quality with multiple connectivity options like HDMI and USB. Its sleek design and user-friendly interface make it a perfect blend of style smart technology.",
    },
    {
      img: LED2,
      name: "43” Smart BTR TV",
      subtitle: "A sleek, frameless Full HD TV featuring immersive sound. Enjoy seamless entertainment with built-in Play Store access and convenient voice control support.",
    },
    {
      img: LED3,
      name: "55” Android LED TV",
      subtitle: "Powered by Android 6.0 OS, this powerful with vibrant visuals, smooth Android performance, built-in apps, and voice control in a stylish, modern design.",
    },
    {
      img: LED4,
      name: "98” WebOS LED TV",
      subtitle: "Our grandest display yet—bringing cinematic visuals, immersive Dolby Audio, and unmatched screen presence for a truly larger-than-life experience.",
    },
  ];

  const cards = [
  {
    image: television,
    title: '24" Non-Smart LED TV',
    tag: 'Designed for compact spaces, this 24” LED TV delivers crisp HD visuals and clear, punchy sound with a built-in woofer. Ideal for basic entertainment and casual gaming in smaller rooms.',
    details: [
      'Resolution: 1280 × 960',
      'Built-in woofer for enhanced sound',
      'Connectivity: 2× HDMI, 2× USB, 1× VGA',
      'Audio Output: 10 Watts',
      'Slim design with free wall mount'
    ]
  },

  {
    image: LED2,
    title: '24" Smart LED TV',
    tag: 'Enjoy the same sleek design with the added power of smart features. Perfect for streaming, casual viewing, and compact setups with smooth performance and rich sound.',
    details: [
      'Resolution: 1280 × 960',
      'Built-in woofer',
      'Smart OS for easy access to apps',
      'Connectivity: HDMI, USB, VGA, Earphone',
      'RAM: 512 MB',
      'Free wall mount & multiple sound modes'
    ]
  },

  {
    image: LED1,
    title: '32" Smart BTR LED TV',
    tag: 'A frameless design meets smart performance. With Chromecast, Google Assistant, and smooth multitasking, this TV is built for a modern, connected viewing experience.',
    details: [
      'HD frameless display',
      'Chromecast & Google Assistant support',
      'RAM: 1 GB | ROM: 8 GB',
      'Dual HDMI & Dual USB',
      'Free wall mount included'
    ]
  },

  {
    image: television,
    title: '55" Android LED TV',
    tag: 'Step into immersive entertainment with a large Ultra HD display powered by Android 6.0. Built for streaming, gaming, and everyday performance.',
    details: [
      'Ultra HD display',
      'Android 6.0 OS',
      'Quad-core processor',
      'RAM: 1 GB | ROM: 8 GB',
      'Ultra HD HDMI, 3× USB',
      'Dual-band Wi-Fi',
      'Free wall mount included'
    ]
  },

  {
    image: LED4,
    title: '65" WebOS LED TV',
    tag: 'Experience stunning clarity and immersive audio with this frameless WebOS LED TV. Designed to elevate your home entertainment with powerful performance and smart connectivity.',
    details: [
      'Ultra 4K HD display',
      'Dolby Audio',
      'Google Assistant',
      'Active Voice Bluetooth Remote',
      'RAM: 2 GB | ROM: 8 GB',
      '3× HDMI, 2× USB',
      'Dual-band Wi-Fi',
      'Free wall mount included'
    ]
  },

  {
    image: wolfled,
    title: '75" WebOS LED TV',
    tag: 'Powered by WebOS, this smart 4K Ultra HD offers impressive picture quality, powerful sound, and an elevated viewing experience built to captivate.',
    details: [
      'Ultra 4K HD display',
      'Dolby Audio',
      'Google Assistant',
      'Active Voice Bluetooth Remote',
      'RAM: 2 GB | ROM: 8 GB',
      '3× HDMI, 2× USB',
      'Dual-band Wi-Fi',
      'Free wall mount included'
    ]
  }
];


  // const cards = [
  //   {
  //     image: television,
  //     title: '24" Non-Smart LED TV',
  //     tag: 'Perfect for compact spaces, this 24" LED TV delivers crisp HD visuals with a built-in woofer for clear, punchy sound. Great for basic entertainment and gaming.',
  //     details: [
  //       'Resolution: 1280x960',
  //       'Audio Output: 10W',
  //       'Connectivity: 2x HDMI, 2x USB, 1x VGA, Earphone Out',
  //       ' RAM: 512MB',
  //       ' Free Wall Mount | Slim Design'
  //     ]
  //   },
 
  //   {
  //     image: LED2,
  //     title: '24" Smart LED TV',
  //     tag: 'The same sleek design with the added benefit of Smart features — perfect for streaming, casual viewing, and compact setups.',
  //     details: [
  //       'Built-in Woofer | Smart OS',
  //       'Resolution: 1280x960',
  //       'Connectivity: HDMI, USB, VGA, EarphoneI',
  //       'RAM: 512MB',
  //       'Free Wall Mount | 5 Sound Modes'
  //     ]
  //   },
  //      {
  //     image: LED1,
  //     title: '32" Smart LED TV',
  //     tag: 'Frameless and feature-rich, this Smart 32" TV supports Chromecast, Google Assistant, and a smooth viewing experience.',
  //     details: [
  //       'RAM: 1GB | ROM: 8GB',
  //       'Chromecast, Google Assistant, Voice Remote',
  //       'Dual USB, Dual HDMI',
  //       'Frameless HD Display | Free Wall Mount'
  //     ]
  //   },
 
  
  //   {
  //     image: television,
  //     title: '55" Android LED TV',
  //     tag: 'Ultra HD display with Android 6.0 and a 4-core processor. Packed with performance for OTT streaming and gaming.',
  //     details: [
  //       'RAM: 1GB | ROM: 8GB',
  //       'Ultra HD | 3 HDMI, 3 USB',
  //       'Dolby Audio | Voice Remote',
  //       'Dual Band Wi-Fi | Free Wall Mount',
  //     ]
  //   },
  //     {
  //     image: LED4,
  //     title: '65" WebOS LED TV',
  //     tag: 'Step into a cinematic experience with this large-screen 4K Ultra HD Smart TV. Voice command and powerful audio included.',
  //     details: [
  //       'RAM: 1GB | ROM: 8GB',
  //       'Dolby Audio | Frameless Design',
  //       'Dual Band Wi-Fi | Free Wall Mount'
  //     ]
  //   },
  //   {
  //     image: wolfled,
  //     title: '85" " WebOS LED TV',
  //     tag: 'Ideal for large home setups, delivering seamless 4K quality and premium sound. Built to impress.',
  //     details: [
  //       'RAM: 1GB | ROM: 8GB',
  //       '3 HDMI, 2 USB | Google Assistant',
  //       'Dolby Audio | Free Wall Mount',
  //     ]
  //   },
  //      {
  //     image: LED3,
  //     title: '98" WebOS LED TV',
  //     tag: 'The grandest display in the range — a true home-theatre experience. Powerful visuals and immersive Dolby audio.',
  //     details: [
  //       '98" Ultra HD Frameless Display',
  //       'Voice Assistant | 3 HDMI, 2 USB',
  //       'Dual Band Wi-Fi | Free Wall Mount',

  //     ]
  //   },
    
  // ];

  const logos = [
    netflix, disney, prime, hulu, spotify, apple, sony,
    // Repeat again for smooth infinite effect
    netflix, disney, prime, hulu, spotify, apple, sony,
  ];

  const trackRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(0);
  const [index, setIndex] = useState(0);
  const updateWidth = () => {
    const card = document.querySelector('.rw-slider-card');
    if (card) setCardWidth(card.offsetWidth + 20); // 20px for margin/gap
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const handleNext = () => {
    const visibleCards = Math.floor(window.innerWidth / cardWidth);
    if (index < cards.length - visibleCards) {
      setIndex(prev => prev + 1);
    }
  };


  const handlePrev = () => {
    if (index > 0) {
      setIndex(prev => prev - 1);
    }
  };

  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${index * cardWidth}px)`;
    }
  }, [index, cardWidth]);


  return (
    <>
     <BrochurePopup
        brochure={tvBrochure}
        title="TV Brochure 2026"
        subtitle="Explore Redwolf Smart TVs with 4K display, Dolby sound, smart features and modern design."
        fileName="Redwolf-TV-Brochure-2026.pdf"
        icon="📺"
      />
      <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={inchled} className="d-block w-100" alt="..." />
          </div>
          <div className="carousel-item">
            <img src={TV} className="d-block w-100" alt="..." />
          </div>
          {/* <div className="carousel-item">
              <img src={banner1} className="d-block w-100" alt="..." />
            </div> */}
          <div className="carousel-item">
            <img src={led3} className="d-block w-100" alt="..." />
          </div>
          {/* <div className="carousel-item">
              <img src={ledad} className="d-block w-100" alt="..." />
            </div> */}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>


      {/* second code */}



      

   <div className="launches-container">
        <h2 style={{ color: " rgb(204, 17, 26)" }}>The Latest Additions</h2>
        <div className="tabs">
          <span className="active-tab">2025 New Lineup</span>
          <span>Mini LED & QLED TVs</span>
        </div>

        {/* <div className="main-featured" >
          <div className="featured-img-box">
            <img src={LED1} alt="LED1" />
            <div className="overlay">
              <h3>32" Smart LED TV</h3>
              <p>Frameless and feature-rich, this Smart 32" TV supports Chromecast, Google Assistant, and a
                smooth viewing experience.</p>
          
            </div>
          </div>
          <p className="caption" style={{
            fontWeight: '600',
            fontSize: '2rem',
            textAlign: 'center',
            marginBottom: '20px',
            margin: '30px',
            fontFamily: 'sans-serif',
            zIndex: 2,
            color: '#cc111a'
          }}><br />Our Top Notch Product's</p>
        </div> */}

          <div className="main-featured">
    {/* <p className="caption">Our Top-Notch Products</p> */}
  <div className="featured-row">

    <div className="featured-card">
    
      <img src={LED1} alt="32 Smart LED TV"  onClick={() => navigate("/contact")}/>
      <div className="featured-content">
        <h3>32″CLOUD LED TV</h3>
        <p>
         Designed with a sleek, frameless profile, this model offers stunning 4K Ultra HD clarity, Dolby Audio, Bluetoothvoice remote, auto update, and seamless performance for smooth streaming and everyday entertainment.
        </p>
      </div>
    </div>

    <div className="featured-card">
      <img src={LED2} alt="43 Smart LED TV"  onClick={() => navigate("/contact")} />
      <div className="featured-content">
        <h3>43″CLOUD LED TV</h3>
        <p>
          Experience breathtaking visuals with a high-performance IPS display panel that delivers vibrant colors and wide viewing angles. Enhanced with Dolby audio for immersive sound and smart connectivity features, this model
ensures a complete entertainment experience.
        </p>
      </div>
    </div>

  </div>

  {/* <p className="caption">Our Top-Notch Products</p> */}
</div>

 <p className="caption">Feature-Packed Models</p> 
{/* <div className="product-slider-wrapper">
  <Swiper
    modules={[Autoplay]}
    spaceBetween={24}
    loop={true}
    speed={900}
    autoplay={{
      delay: 2500,
      disableOnInteraction: false,
    }}
    breakpoints={{
      320: { slidesPerView: 1.2 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    }}
  >
    {products.map((product, index) => (
      <SwiperSlide key={index}>
        <div
          className="product-card"
          onClick={() => navigate("/contact")}
        >
          <img src={product.img} alt={product.name} />
          <h4>{product.name}</h4>
          <p>{product.subtitle}</p>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div> */}

        <div className="product-grid">
          {products.map((product, index) => (
            <div className="product-card" key={index}>
              <img src={product.img} alt={product.name}  onClick={() => navigate("/contact")}/>
              {/* <h4 className="co">{product.name}</h4> */}
              <h4 id="product-name" className="co">
  {product.name}
</h4>

              <p>{product.subtitle}</p>
            </div>
          ))}
        </div>
      </div> 




  {/* <div className="main-featured">
    <p className="caption">Our Top-Notch Products</p>
  <div className="featured-row">

    <div className="featured-card">
      <img src={LED1} alt="32 Smart LED TV" />
      <div className="featured-content">
        <h3>32″ Smart LED TV</h3>
        <p>
          Frameless Smart TV with Chromecast, Google Assistant and smooth HD viewing.
        </p>
      </div>
    </div>

    <div className="featured-card">
      <img src={LED2} alt="43 Smart LED TV" />
      <div className="featured-content">
        <h3>43″ Full HD LED TV</h3>
        <p>
          Powerful sound, vivid colors and smart connectivity for immersive entertainment.
        </p>
      </div>
    </div>

  </div>


</div> */}






      {/* theard card  */}



      <section className="rw-slider-section">
        {/* <h2 style={{ color: 'rgb(204, 17, 26)' }}>Discover More with Red Wolf</h2> */}
          <h2 className="caption">Discover More with Red Wolf</h2>
        <div className="rw-slider-container">
          <button className="rw-slider-btn prev" onClick={handlePrev}>&#8249;</button>

          <div className="rw-slider-track" ref={trackRef}>
            {cards.map((card, i) => (
              <div className="rw-slider-card" key={i}>
                <img src={card.image}  onClick={() => navigate("/contact")} alt={`Slide ${i}`} />
                <h4 className="tit">{card.title}</h4>
                <span>{card.tag}</span>
                {card.details && (
                  <p>
                    {card.details.map((line, idx) => (
                      <span key={idx}>{line}<br /></span>
                    ))}
                  </p>
                )}
              </div>
            ))}
          </div>

          <button className="rw-slider-btn next" onClick={handleNext}>&#8250;</button>
        </div>
      </section>
      <section className="pf-section">
  <h2 className="pf-heading">Powerful Features Across Models</h2>

  <div className="pf-container">

    <div className="fc1">
      <img src={dolbyGif} alt="Dolby Audio" className="fc-img" />
      <h3 className="fc-title">1. Dolby Audio</h3>
      <p className="fc-text">
        Delivers rich, clear, and immersive sound quality with enhanced bass
        and crystal-clear dialogue for movies and music.
      </p>
    </div>

    <div className="fc2">
      <img src={assistantGif} alt="Google Assistant" className="fc-img" />
      <h3 className="fc-title">2. Google Assistant</h3>
      <p className="fc-text">
        Built-in voice control to search content, open apps,
        control smart devices and more using simple commands.
      </p>
    </div>

    <div className="fc3">
      <img src={movieGif} alt="MovieBox" className="fc-img" />
      <h3 className="fc-title">3. MovieBox</h3>
      <p className="fc-text">
        Pre-installed entertainment platform with movies,
        TV shows, and seamless streaming experience.
      </p>
    </div>

    <div className="fc4">
      <img src={remoteGif} alt="Bluetooth Voice Remote" className="fc-img" />
      <h3 className="fc-title">4. Bluetooth Voice Remote</h3>
      <p className="fc-text">
        Smart Bluetooth remote with voice support for smooth
        navigation and easy TV control.
      </p>
    </div>

    <div className="fc5">
      <img src={updateGif} alt="Auto Update" className="fc-img" />
      <h3 className="fc-title">5. Auto Update</h3>
      <p className="fc-text">
        Automatically updates TV software to improve performance,
        security, and new feature access.
      </p>
    </div>

  </div>
</section>

{/* <section className="power-features">
  <h2 className="features-heading">Powerful Features Across Models</h2>

  <div className="features-container">

    <div className="feature-card">
      <img src={dolbyGif} alt="Dolby Audio" className="feature-gif" />
      <h3>1. Dolby Audio</h3>
      <p>
        Delivers rich, clear, and immersive sound quality. It enhances dialogue clarity,
        deepens bass, and creates a surround sound experience for movies and music.
      </p>
    </div>

    <div className="feature-card">
      <img src={assistantGif} alt="Google Assistant" className="feature-gif" />
      <h3>2. Google Assistant</h3>
      <p>
        Built-in voice control that allows you to search content, open apps,
        control smart devices, check weather updates, and more — using simple voice commands.
      </p>
    </div>

    <div className="feature-card">
      <img src={movieGif} alt="MovieBox" className="feature-gif" />
      <h3>3. MovieBox</h3>
      <p>
        Pre-installed entertainment platform providing access to movies,
        TV shows, and digital content for seamless streaming.
      </p>
    </div>

    <div className="feature-card">
      <img src={remoteGif} alt="Bluetooth Voice Remote" className="feature-gif" />
      <h3>4. Bluetooth Voice Remote</h3>
      <p>
        Smart Bluetooth remote with voice support for easy navigation,
        content search, and smooth control without pointing at the TV.
      </p>
    </div>

    <div className="feature-card">
      <img src={updateGif} alt="Auto Update" className="feature-gif" />
      <h3>5. Auto Update</h3>
      <p>
        Automatically updates TV software in the background to ensure
        improved performance, better security, and latest features.
      </p>
    </div>

  </div>
</section> */}

      


      {/* FOURTH SECTION */}

      <section>
        {/* <img src={Advertise} alt="advertise" style={{ width: '100%' }} /> */}
        <br />
        <div className="ott-slider">
          <div className="slider-track">
            {logos.map((logo, index) => (
              <div className="ott-slide" key={index}>
                <img src={logo} alt={`logo-${index}`} />
              </div>
            ))}
          </div>
        </div>

        <img src={Last} alt="advertiselast" style={{ width: '100%' }} />

      </section>












      {/* <section className="power-features">
  <h2 className="features-heading">Powerful Features Across Models</h2>

  <div className="features-container">
    
    <div className="feature-item">
      <h3>1. Dolby Audio</h3>
      <p>
        Delivers rich, clear, and immersive sound quality. It enhances dialogue clarity,
        deepens bass, and creates a surround sound experience for movies, music, and shows.
      </p>
    </div>

    <div className="feature-item">
      <h3>2. Google Assistant</h3>
      <p>
        A built-in voice control feature that allows you to search content, open apps,
        control smart devices, check weather updates, and more — all with simple voice commands.
      </p>
    </div>

    <div className="feature-item">
      <h3>3. MovieBox</h3>
      <p>
        A pre-installed entertainment platform that provides access to a wide range of
        movies, TV shows, and digital content for convenient streaming.
      </p>
    </div>

    <div className="feature-item">
      <h3>4. Bluetooth Voice Remote</h3>
      <p>
        A smart remote that connects via Bluetooth and supports voice commands,
        allowing you to control your TV, search content, and navigate easily without
        pointing directly at the screen.
      </p>
    </div>

    <div className="feature-item">
      <h3>5. Auto Update</h3>
      <p>
        Automatically updates the TV software in the background to ensure improved
        performance, security enhancements, and access to the latest features without manual installation.
      </p>
    </div>

  </div>
</section> */}

      <section className="tv-brochure-section">
  <div className="tv-brochure-card">
    <div className="tv-brochure-content">
      <h2>
        Your Guide to Our Latest <span>LED TVs</span>
      </h2>

      <p>
        Explore our latest LED TV lineup, featuring detailed specifications,
        advanced display technology, available sizes, smart features, and
        warranty information—all in one comprehensive brochure.
      </p>

      <a
        href={tvBrochure}
        download
        className="brochure-btn tv-btn"
      >
        📺 Download TV Brochure
      </a>
    </div>
  </div>
</section>

{/* <section className="tv-brochure-section">
  <div className="tv-brochure-card">
    <div className="tv-brochure-content">
      <h2>
        Download <span>LED TV Brochure</span>
      </h2>

      <p>
        Discover our latest LED TV lineup with full specifications,
        display technology, smart features, sizes, and warranty details
        in one complete brochure.
      </p>

      <a
        href={tvBrochure}
        download
        className="brochure-btn tv-btn"
      >
        📺 Download TV Brochure
      </a>
    </div>
  </div>
</section> */}


    </>
  )
}











